import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as FAQIcon } from 'assets/icons/faq-icon.svg'
import { ReactComponent as EMailIcon } from 'assets/icons/mail-email-icon.svg'
import { ReactComponent as WhatsAppIcon } from 'assets/icons/whats-app-icon.svg'

import { Container, Content, ReturnButton } from "./_support"
import { Link } from "react-router-dom"

export const Support = () => {
  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <ReturnButton to="/">
          <LeftArrow
            className="support__content-icon"
          />
        </ReturnButton>
        <div className="support__content-wrapper">
          <h1 className="support__content-title">
            Algum problema ou dúvida?
            <br />
            Entre em contato para podermos te ajudar.
          </h1>
          <ul>
            <Link to="/suporte/faq" className="support__content-button">
              <div className="support__content-icon-container">
                <FAQIcon />
              </div>
              <h1 className="support__content-button-text">
                REPFAQ - Perguntas mais frequentes
              </h1>
            </Link>
            <a href="mailto:suporte@repfy.com.br" className="support__content-button">
              <div className="support__content-icon-container">
                <EMailIcon />
              </div>
              <h1 className="support__content-button-text">
                Enviar E-mail ao suporte REPFY
              </h1>
            </a>
            <a href="https://wa.me/5511966408643" className="support__content-button" target="_blank" rel="noreferrer">
              <div className="support__content-icon-container">
                <WhatsAppIcon />
              </div>
              <h1 className="support__content-button-text">
                Converse com nossa equipe via Whatsapp
              </h1>
            </a>
          </ul>
        </div>
      </Content>
    </Container>
  )
}
